import { render, staticRenderFns } from "./EditList.vue?vue&type=template&id=6e126c50"
import script from "./EditList.vue?vue&type=script&lang=ts"
export * from "./EditList.vue?vue&type=script&lang=ts"
import style0 from "./EditList.vue?vue&type=style&index=0&id=6e126c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports